import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { buildAppMenu } from '../../../common/data/menuData';
import AuthContext from '../../../contexts/authContext';
import ThemeContext from '../../../contexts/themeContext';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { dashboardPagesMenu } from '../../../menu';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { userData } = useContext(AuthContext);

	const [doc, setDoc] = useState(localStorage.getItem('facit_asideDocStatus') === 'true' || false);

	const { t } = useTranslation(['translation', 'menu']);

	const allowedMenus = buildAppMenu(userData.menus || []);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={dashboardPagesMenu} id='aside-dashboard' />
				<NavigationLine />
				<Navigation menu={allowedMenus} id='app-menu' />
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
